<template>
  <main style="background-color: #274c8e">
    <div
      class="carousel-container"
      @touchstart="onTouchStart"
      @touchend="onTouchEnd"
    >
      <transition name="fade" tag="div">
        <section
          v-if="carouselBackgrounds.length"
          id="jumbotron"
          class="jumbotron"
          :key="current_index"
          :style="{
            backgroundImage: isMobile
              ? `url(${carouselBackgrounds[current_index].image_croped})`
              : `url(${carouselBackgrounds[current_index].image_url})`,
            backgroundPosition:
              carouselBackgrounds[current_index].id === 3
                ? '60% center'
                : 'center 5%',
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
          }"
        >
          <div class="jumbotron-overlay">
            <div class="carousel-props">
              <!-- Buttons -->
              <button class="carousel-prev-slide" @click="prevSlide">‹</button>
              <button class="carousel-next-slide" @click="nextSlide">›</button>

              <!-- Dots -->
              <div class="carousel-indicators">
                <span
                  v-for="(item, index) in carouselBackgrounds"
                  :key="index"
                  :class="{
                    'indicator-not-active': index !== current_index,
                    'indicator-active': index === current_index,
                  }"
                  @click="goToSlide(index)"
                ></span>
              </div>
            </div>
          </div>

          <!-- Header -->
          <section id="header" class="container">
            <div class="header-container">
              <h3 class="header-sub-title">
                {{ carouselBackgrounds[current_index].sub_title }}
              </h3>
              <h3
                class="header-title"
                v-html="carouselBackgrounds[current_index].title"
              ></h3>
              <p
                v-html="carouselBackgrounds[current_index].description"
                class="header-description"
              ></p>
              <template v-if="carouselBackgrounds[current_index].button">
                <router-link
                  v-if="carouselBackgrounds[current_index].button"
                  :to="carouselBackgrounds[current_index].button.pathName"
                  class="btn-carousel-action"
                >
                  {{ carouselBackgrounds[current_index].button.label }}
                </router-link>
              </template>
            </div>
          </section>
        </section>
      </transition>
      <!-- Sidebar -->
      <transition name="sidebar">
        <aside v-if="is_open_sidebar" class="sidebar">
          <div class="aside-header">
            <img
              alt="efunding-logo"
              :src="
                require(`@/assets/images/landing_page/img-logo-efunding.png`)
              "
              class="logo-img"
            />
            <button class="icon-button" @click="sidebarToggle">
              <XmarkIcon style="width: 2rem; height: 2rem; color: #606060" />
            </button>
          </div>
          <div class="menu-container">
            <a
              :class="
                currentPath === menu.pathname ? 'menu-item-active' : 'menu-item'
              "
              v-for="(menu, index) in navbarMenu"
              :key="index"
              :href="menu.pathname"
            >
              {{ menu.label }}
            </a>
          </div>
        </aside>
      </transition>
    </div>

    <section 
      id="efunding-services" 
      class="container"
      :class="{ 'efunding-services-visible': isServicesVisible }"
    >
      <div class="reveal-on-scroll">
        <h2 class="section-header">
          Layanan <span class="section-header-orange">Efunding</span>
        </h2>
        <p class="section-description">
          Temukan berbagai produk keuangan syariah yang komprehensif dan dirancang
          untuk memenuhi kebutuhan serta aspirasi finansial Anda.
        </p>
      </div>
      <div class="row">
        <div
          class="col-12 col-md-4 mt-3"
          v-for="(data, index) in efundingServices"
          :key="index"
        >
          <div class="service-card-wrapper" @click="handleIconClick(data)">
            <!-- Ribbon Banner (Coming Soon) for Pembiayaan Syariah -->
            <div v-if="data.id === 3" class="ribbon-wrapper">
              <div class="ribbon-text">Segera Hadir</div>
            </div>
            <div class="service-card-glow"></div>
            <div class="service-card-inner">
              <div class="service-icon-container">
                <img :src="data.icon" :alt="data.label" class="service-icon" />
              </div>
              <h3 class="service-title">{{ data.label }}</h3>
              <p class="service-description-text">{{ data.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="efunding-pros" class="pros-normal-container container">
      <div class="reveal-on-scroll">
        <h2 class="section-header text-center">
          Mengapa <span class="section-header-orange">Efunding?</span>
        </h2>
        <p class="section-description text-center mb-5">
          Di Efunding, kami melayani beragam kebutuhan Perorangan maupun Pelaku
          Bisnis, dengan menyediakan berbagai solusi keuangan syariah yang luas
          dan komprehensif.
        </p>
      </div>

      <div class="pros-views-wrapper">
        <!-- View 1: Perorangan -->
        <div class="pros-view-pane pane-personal mb-5 pb-5">
          <div class="row align-items-center">
            <div class="col-12 col-lg-6 px-4 px-lg-0 pr-lg-5 mb-4 mb-lg-0 reveal-on-scroll">
              <CardAbstract cardType="personal" />
            </div>
            <div class="col-12 col-lg-6 px-4 px-lg-0 pl-lg-5 reveal-on-scroll">
              <h3 class="pros-header text-left">Bagi Perorangan</h3>
              <p class="section-description text-left">
                Bagi perorangan, layanan simpanan dan pembiayaan melalui platform
                kami memberikan kemudahan akses untuk mengelola keuangan pribadi,
                membangun tabungan masa depan, merencanakan pendanaan pendidikan,
                serta mewujudkan kepemilikan kendaraan dan rumah impian sebagai
                bagian dari perencanaan finansial jangka panjang yang terarah dan
                terpercaya, melalui teknologi yang handal Efunding siap membantu
                Anda!.
              </p>
              <div class="row mt-4 pros-features-row">
                <div class="col-12 col-md-4 mb-3 d-flex justify-content-center">
                  <div class="pros-feature-card">
                    <div class="pros-feature-glow"></div>
                    <div class="pros-feature-icon-wrapper">
                      <img :src="ShieldIcon" alt="ic-shield" class="pros-feature-icon" />
                    </div>
                    <p class="pros-feature-text">Perencanaan<br />Keuangan</p>
                  </div>
                </div>
                <div class="col-12 col-md-4 mb-3 d-flex justify-content-center">
                  <div class="pros-feature-card">
                    <div class="pros-feature-glow"></div>
                    <div class="pros-feature-icon-wrapper">
                      <img :src="ShieldIcon" alt="ic-shield" class="pros-feature-icon" />
                    </div>
                    <p class="pros-feature-text">Kemudahan<br />Transaksi</p>
                  </div>
                </div>
                <div class="col-12 col-md-4 mb-3 d-flex justify-content-center">
                  <div class="pros-feature-card">
                    <div class="pros-feature-glow"></div>
                    <div class="pros-feature-icon-wrapper">
                      <img :src="ShieldIcon" alt="ic-shield" class="pros-feature-icon" />
                    </div>
                    <p class="pros-feature-text">Kepastian<br />Syariah</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <!-- View 2: Pelaku Bisnis -->
        <div class="pros-view-pane pane-company">
          <div class="row align-items-center">
            <div class="col-12 col-lg-6 px-4 px-lg-0 pr-lg-5 order-2 order-lg-1 reveal-on-scroll">
              <h3 class="pros-header text-left">Bagi Pelaku Bisnis</h3>
              <p class="section-description text-left">
                Bagi pelaku bisnis, Efunding menghadirkan layanan simpanan dan
                pembiayaan syariah yang mendukung pengelolaan keuangan usaha secara
                optimal. Kami mendorong pertumbuhan melalui solusi modal kerja yang
                memperkuat arus kas, serta pembiayaan berbasis kebutuhan yang
                dirancang khusus untuk mendukung ekspansi dan keberlanjutan bisnis
                Anda. Apa pun tujuan finansialnya, Efunding siap menjadi mitra
                terpercaya dalam perjalanan bisnis Anda.
              </p>
              <div class="row mt-4 pros-features-row">
                <div class="col-12 col-md-4 mb-3 d-flex justify-content-center">
                  <div class="pros-feature-card">
                    <div class="pros-feature-glow"></div>
                    <div class="pros-feature-icon-wrapper">
                      <img :src="ShieldIcon" alt="ic-shield" class="pros-feature-icon" />
                    </div>
                    <p class="pros-feature-text">Pengelolaan<br />Keuangan</p>
                  </div>
                </div>
                <div class="col-12 col-md-4 mb-3 d-flex justify-content-center">
                  <div class="pros-feature-card">
                    <!-- Ribbon Banner (Coming Soon) -->
                    <div class="ribbon-wrapper">
                      <div class="ribbon-text">Segera Hadir</div>
                    </div>
                    <div class="pros-feature-glow"></div>
                    <div class="pros-feature-icon-wrapper">
                      <img :src="ShieldIcon" alt="ic-shield" class="pros-feature-icon" />
                    </div>
                    <p class="pros-feature-text">Mendorong<br />Perluasan Bisnis</p>
                  </div>
                </div>
                <div class="col-12 col-md-4 mb-3 d-flex justify-content-center">
                  <div class="pros-feature-card">
                    <div class="pros-feature-glow"></div>
                    <div class="pros-feature-icon-wrapper">
                      <img :src="ShieldIcon" alt="ic-shield" class="pros-feature-icon" />
                    </div>
                    <p class="pros-feature-text">Kepastian<br />Syariah</p>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-12 col-lg-6 px-4 px-lg-0 pl-lg-5 mb-4 mb-lg-0 order-1 order-lg-2 reveal-on-scroll">
              <CardAbstract cardType="company" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="efunding-partners" class="container">
      <div class="reveal-on-scroll">
        <h2 class="section-header">
          Mitra <span class="section-header-orange">Efunding</span>
        </h2>
        <p class="section-description">
          Kami bekerja sama dengan deretan
          <b>BPRS (Bank Perekonomian Rakyat Syariah)</b> yang resmi berizin OJK,
          terdaftar dan dijamin oleh LPS<br />
          Karena kepercayaan Anda adalah prioritas utama kami.
        </p>
      </div>

      <div
        class="partner-marquee-wrapper reveal-on-scroll"
        @mouseenter="pauseScroll"
        @mouseleave="resumeScroll"
      >
        <div class="partner-marquee">
          <div class="partner-track">
            <div
              v-for="(partner, index) in partners"
              :key="index"
              class="partner-item"
            >
              <img :src="partner.logo" :alt="partner.name" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section id="efunding-selected-product" class="container">
      <div class="reveal-on-scroll">
        <h2 class="section-header">
          Produk-Produk <span class="section-header-orange">Pilihan</span>
        </h2>
        <p class="section-description">
          Jelajahi beragam produk unggulan di Efunding, mulai dari produk simpanan
          maupun produk pembiayaan, layanan pengajuan daring yang mulus, transaksi
          yang aman, hingga wawasan keuangan yang dipersonalisasi, semua dirancang
          untuk meningkatkan pengalaman perbankan syariah Anda secara menyeluruh.
        </p>
      </div>

      <div class="reveal-on-scroll">
        <CardProduct @update-data-exists="handleDataExists" />
      </div>

      <div class="text-center mt-4 reveal-on-scroll">
        <!-- Tombol awal -->
        <button
          v-if="!showProductButtons && showButton"
          @click="showProductButtons = true"
          class="btn btn-primary"
          style="
            background-color: #002a73;
            color: white;
            border-radius: 30px;
            padding: 10px 20px;
          "
        >
          Lihat Semua Produk
        </button>

        <!-- Tombol pilihan produk + tombol X -->
        <div
          v-if="showProductButtons"
          class="d-flex flex-column align-items-center product-button-group"
        >
          <div class="d-flex flex-wrap justify-content-center gap-3 mb-3">
            <router-link
              to="/list-produk-deposito"
              class="btn btn-primary"
              style="
                margin-right: 20px;
                background-color: #002a73;
                color: white;
                border-radius: 30px;
                padding: 10px 20px;
                text-decoration: none;
              "
            >
              Produk Deposito
            </router-link>
            <router-link
              to="/list-produk-tabungan"
              class="btn btn-primary"
              style="
                background-color: #002a73;
                color: white;
                border-radius: 30px;
                padding: 10px 20px;
                text-decoration: none;
              "
            >
              Produk Tabungan
            </router-link>
          </div>

          <button
            @click="showProductButtons = false"
            class="btn btn-outline-secondary"
            style="
              border-radius: 30px;
              padding: 6px 16px;
              background-color: transparent;
              border: transparent;
            "
          >
            ❌
          </button>
        </div>
      </div>
    </section>

    <section id="efunding-faq" class="container">
      <div class="reveal-on-scroll">
        <h2 class="section-header">
          <span class="section-header-orange">Frequently</span> Asked Questions
        </h2>
        <p class="section-description">
          Masih memiliki pertanyaan? Silakan hubungi tim kami melalui email di
          support@efunding.id
        </p>
      </div>
      <div class="reveal-on-scroll">
        <CardFaq :faq="efundingFaq" />
      </div>
    </section>

    <ModalSegeraHadir
      :visible="SegeraHadirVisible"
      @close="closeModalProperly"
    />

    <div class="reveal-on-scroll">
      <CardGetStarted />
    </div>

    <PopUpCTA />

    <NewFooterClient />
  </main>
</template>

<script>
// Icons
import Bars3Icon from "@/components/icons/Bars3Icon.vue";
import XmarkIcon from "@/components/icons/XmarkIcon.vue";

// Components
import CardAbstract from "@/components/landing-page/cardAbstract.vue";
import CardProduct from "@/components/landing-page/cardProduct.vue";
import CardFaq from "@/components/landing-page/cardFaq.vue";
import CardGetStarted from "@/components/landing-page/cardGetStarted.vue";
import NewFooterClient from "@/components/landing-page/newFooterClient.vue";
import ModalSegeraHadir from "@/components/ModalSegeraHadir.vue";
import PopUpCTA from "@/components/PopUpCTA.vue";

// Assets
import ShieldIcon from "@/assets/images/landing_page/ic-shield.svg";

// Utils
import { navbarMenu } from "@/utils/navbar_menu.js";
import { carouselBackgrounds } from "@/utils/carousel_backgrounds.js";
import { efundingServices } from "@/utils/efunding_services.js";
import { efundingPartnersLogo } from "@/utils/efunding_partners_logo.js";
import { efundingSelectedProduct } from "@/utils/efunding_selected_product.js";
import { efundingFaq } from "@/utils/efunding_faq.js";
import Product from "../api/produk";

export default {
  components: {
    Bars3Icon,
    XmarkIcon,
    CardAbstract,
    CardProduct,
    CardFaq,
    CardGetStarted,
    NewFooterClient,
    ModalSegeraHadir,
    PopUpCTA,
  },
  data() {
    return {
      is_open_sidebar: false,
      navbarMenu,
      carouselBackgrounds,
      current_index: 0, // Set initial index to 0
      ShieldIcon,
      efundingServices,
      efundingSelectedProduct,
      efundingFaq,
      partners: [...efundingPartnersLogo],
      visiblePartners: [],
      isPaused: false,
      showButton: false,
      showProductButtons: false,
      SegeraHadirVisible: false,
      isServicesVisible: false,
      screenWidth: typeof window !== 'undefined' ? window.innerWidth : 1200,
    };
  },
  computed: {
    currentPath() {
      return this.$route.path;
    },
    duplicatedPartners() {
      return [...this.efundingPartnersLogo, ...this.efundingPartnersLogo];
    },
    currentSlide() {
      return this.carouselBackgrounds[this.current_index];
    },

    marqueeAnimation() {
      return this.isPaused ? "none" : "scroll-left 30s linear infinite";
    },
    isMobile() {
      return this.screenWidth <= 768;
    },
  },
  mounted() {
    this.updateScreenWidth();
    this.preloadBackgrounds();
    this.visiblePartners = [...this.partners, ...this.partners]; // awalnya dobel
    window.addEventListener("resize", this.updateScreenWidth);
    
    // Intersection Observer for scroll animations
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.isServicesVisible = true;
            obs.unobserve(entry.target); // Keep visible once animated
          }
        });
      }, {
        threshold: 0.15,
        rootMargin: '0px 0px -150px 0px'
      });
      
      const servicesSection = document.getElementById('efunding-services');
      if (servicesSection) {
        observer.observe(servicesSection);
      }
      this.servicesObserver = observer;

      // Setup general scroll reveal animations
      const revealObserver = new IntersectionObserver((entries, obs) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
            obs.unobserve(entry.target);
          }
        });
      }, {
        threshold: 0.10,
        rootMargin: '0px 0px -150px 0px'
      });
      
      this.$el.querySelectorAll('.reveal-on-scroll').forEach(el => {
        revealObserver.observe(el);
      });
      this.revealObserver = revealObserver;
    } else {
      this.isServicesVisible = true;
      this.$el.querySelectorAll('.reveal-on-scroll').forEach(el => {
        el.classList.add('revealed');
      });
    }

    this.carouselInterval = setInterval(() => {
      this.nextSlide();
    }, 5000);
  },
  beforeDestroy() {
    clearInterval(this.carouselInterval); // untuk carousel autoplay
    if (this.servicesObserver) {
      this.servicesObserver.disconnect();
    }
    if (this.revealObserver) {
      this.revealObserver.disconnect();
    }
  },

  methods: {
    preloadBackgrounds() {
      if (this.carouselBackgrounds) {
        this.carouselBackgrounds.forEach((item) => {
          if (item.image_url) {
            const img = new Image();
            img.src = item.image_url;
          }
          if (item.image_croped) {
            const img = new Image();
            img.src = item.image_croped;
          }
        });
      }
    },
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
    },
    handleDataExists(exists) {
      this.showButton = exists;
    },
    sidebarToggle() {
      this.is_open_sidebar = !this.is_open_sidebar;
    },
    nextSlide() {
      this.current_index =
        (this.current_index + 1) % this.carouselBackgrounds.length;
    },
    prevSlide() {
      this.current_index =
        (this.current_index - 1 + this.carouselBackgrounds.length) %
        this.carouselBackgrounds.length;
    },
    onTouchStart(e) {
      this.touchStartX = e.changedTouches[0].clientX;
    },
    onTouchEnd(e) {
      const touchEndX = e.changedTouches[0].clientX;
      const diffX = touchEndX - this.touchStartX;
      if (diffX > 50) {
        this.prevSlide();
      } else if (diffX < -50) {
        this.nextSlide();
      }
    },
    pauseScroll() {
      this.isPaused = true;
    },
    resumeScroll() {
      this.isPaused = false;
    },
    carouselJumbotronNextSlide() {
      this.current_index =
        (this.current_index + 1) % this.carouselBackgrounds.length;
    },
    carouselJumbotronPrevSlide() {
      this.current_index =
        (this.current_index - 1 + this.carouselBackgrounds.length) %
        this.carouselBackgrounds.length;
    },
    goToSlide(index) {
      this.current_index = index;
    },
    openSegeraHadirModal() {
      this.SegeraHadirVisible = true;
    },
    closeModalProperly() {
      this.SegeraHadirVisible = false;
    },
    handleIconClick(data) {
      console.log("Icon diklik:", data);

      if (data.id === 1) {
        // Jika Tabungan Syariah
        this.$router.push(`/list-produk-tabungan`);
      } else if (data.id === 2) {
        // Jika Deposito Syariah
        this.$router.push(`/list-produk-deposito`);
      } else {
        // Jika selain itu (contoh: Pembiayaan Syariah)
        // Ubah sesuai kebutuhan atau tambahkan rute lain
        this.openSegeraHadirModal();
      }

      // Atau tampilkan modal detail
      // this.selectedService = data;
      // this.showModal = true;

      // Atau jalankan aksi lain
      // alert(`Kamu klik ${data.label}`);
    },
  },
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.8s ease-in-out;
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.slide-enter-active,
.slide-leave-active {
  transition: all 0.5s ease;
  position: absolute;
  width: 100%;
}
.slide-enter {
  transform: translateX(100%);
  opacity: 0;
}
.slide-leave-to {
  transform: translateX(-100%);
  opacity: 0;
}
.btn-carousel-action {
  display: inline-block;
  padding: 20px 24px;
  background-color: #f7bd3a;
  color: #ffffff;
  font-weight: 600;
  font-size: 16px;
  border: none;
  border-radius: 9999px;
  max-width: 270px;
  text-align: center;
  text-decoration: none;
  transition: background-color 0.3s ease;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.15);
}

.btn-carousel-action:hover {
  background-color: #e0a02e; /* lebih gelap sedikit */
  cursor: pointer;
}
.product-button-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
  margin-bottom: 16px;
}
.carousel-container {
  position: relative;
  overflow: hidden;
  height: 100dvh;
}
.jumbotron {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center 50%;
  z-index: 0;
}
.jumbotron-overlay {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.2); /* hitam transparan */
  z-index: 1;
}

/* --- JUMBOTRON SLIDE TEXT ENTRANCE ANIMATIONS (VUE TRANSITION BASED) --- */
.header-sub-title,
.header-title,
.header-description,
.btn-carousel-action {
  opacity: 1;
  transform: translateY(0);
}

/* Initial state when the slide starts entering */
.fade-enter .header-sub-title,
.fade-enter .header-title,
.fade-enter .header-description,
.fade-enter .btn-carousel-action {
  opacity: 0;
  transform: translateY(30px);
}

/* Active transition rules for staggered entrance */
.fade-enter-active .header-sub-title {
  transition: transform 0.8s cubic-bezier(0.25, 1, 0.5, 1), opacity 0.8s ease;
}

.fade-enter-active .header-title {
  transition: transform 0.8s cubic-bezier(0.25, 1, 0.5, 1) 0.15s, opacity 0.8s ease 0.15s;
}

.fade-enter-active .header-description {
  transition: transform 0.8s cubic-bezier(0.25, 1, 0.5, 1) 0.3s, opacity 0.8s ease 0.3s;
}

.fade-enter-active .btn-carousel-action {
  transition: transform 0.8s cubic-bezier(0.25, 1, 0.5, 1) 0.45s, opacity 0.8s ease 0.45s;
}

.navbar-container {
  position: sticky !important; /* Still in flow, but above the background */
  top: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1rem;
  background-color: transparent;
}
.menu-container {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-top: 2rem;
}
.menu-item {
  font-size: 18px;
}
.menu-item-active {
  font-size: 18px;
  color: #274c8e;
  font-weight: 600;
  border-bottom: 2px solid #274c8e;
  max-width: fit-content;
}
.icon-button {
  all: unset;
}

.pros-header {
  font-size: 20px;
  color: white;
}

/* Sidebar */
aside {
  position: fixed;
  top: 0;
  background-color: white;
  z-index: 10;
  height: 100dvh;
  width: 100%;
  padding: 1rem;
}
.aside-header {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
}

/* Transition CSS */
.sidebar-enter-active,
.sidebar-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.sidebar-enter,
.sidebar-leave-to {
  transform: translateX(100%);
  opacity: 0;
}
.sidebar-enter-to,
.sidebar-leave-from {
  transform: translateX(0);
  opacity: 1;
}

.section-header {
  color: white;
  font-weight: 700;
  margin-bottom: 0.5rem;
  text-transform: capitalize;
}

.section-header-orange {
  color: #f7bd3a;
  font-weight: 700;
  margin-bottom: 0.5rem;
}

.section-description {
  color: #b3b3b3;
}

.navbar-menu-item {
  color: white;
  font-size: 18px;
  transition: all 1s;
  font-weight: 600;
  cursor: pointer;
}

.navbar-menu-item:hover {
  color: #274c8e;
  border-bottom: 4px solid #274c8e;
  background-color: transparent !important;
}

/* Button Style */
.button-primary {
  padding: 15px 25px;
  background-color: #f7bd3a;
  color: white;
  font-weight: 600;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  border: none;
  border-radius: 50px;
  box-shadow: 0 4px 12px rgba(247, 189, 58, 0.25);
}
.button-primary:hover {
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 8px 20px rgba(247, 189, 58, 0.45);
  background-color: #f6b523 !important;
  color: #13346c !important;
}
.button-primary:active {
  transform: translateY(0) scale(1);
}

.button-secondary {
  padding: 15px 25px;
  background-color: #274c8e;
  color: white;
  font-weight: 600;
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
  border: none;
  border-radius: 50px;
  box-shadow: 0 4px 12px rgba(39, 76, 142, 0.25);
}
.button-secondary:hover {
  transform: translateY(-2px) scale(1.05);
  box-shadow: 0 8px 20px rgba(39, 76, 142, 0.45);
  background-color: #1e3a6d !important;
}
.button-secondary:active {
  transform: translateY(0) scale(1);
}

.partner-list-wrapper {
  overflow-x: hidden;
  white-space: nowrap;
  padding-bottom: 10px; /* biar ga potong shadow/img */
  background-color: white;
  border-radius: 100px;
  width: 100%;
}

.partner-list-scroll {
  display: flex;
  gap: 1rem;
  align-items: center;
  overflow-x: auto;
  padding-left: 5%;
  max-width: 100%;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* IE 10+ */
}

.partner-list-scroll::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera */
}

.partner-item-scroll {
  flex: 0 0 auto; /* Ini penting, biar item gak shrink atau wrap */
  scroll-snap-align: start;
  min-width: 150px; /* atur sesuai kebutuhan */
  border-radius: 12px;
  padding: 1rem;
  color: white;
  text-align: center;
}

.carousel-prev-slide {
  position: absolute;
  top: 50%;
  left: 2%;
  z-index: 999;
  color: white;
  background-color: transparent;
  border: none;
  font-size: 64px;
  padding: 0;
}

.carousel-next-slide {
  position: absolute;
  top: 50%;
  right: 3%;
  z-index: 999;
  color: white;
  background-color: transparent;
  border: none;
  font-size: 64px;
  padding: 0;
}

.carousel-indicators {
  position: absolute;
  bottom: 10%;
  z-index: 99999999;
  display: flex;
  gap: 8px;
}

.indicator-active {
  position: relative;
  height: 10px;
  width: 10px;
  border-radius: 100%;
  background-color: #274c8e;
  cursor: pointer;
  pointer-events: auto;
  z-index: 999999;
}

.indicator-not-active {
  position: relative;
  height: 10px;
  width: 10px;
  border-radius: 100%;
  background-color: #fff;
  cursor: pointer;
  pointer-events: auto;
  z-index: 999999;
}

.carousel-props {
  position: relative;
  z-index: 999;
  background-color: transparent;
  height: 100dvh;
  width: 100dvw;
}
.partner-marquee-wrapper {
  overflow: hidden;
  width: 100%;
  background-color: #f9f9f9;
  padding: 20px 0;
  margin-top: 120px;
  position: relative;
  border-radius: 100px;
}

.partner-marquee {
  display: flex;
  animation: scroll-left 30s linear infinite;
  -webkit-animation: scroll-left 30s linear infinite;
  /* Membuat elemen marquee flex agar bisa di-scroll */
  width: auto;
  min-width: 100%;
}

.partner-track {
  display: flex;
  width: auto;
  /* Pastikan lebar sesuai dengan konten di dalamnya */
  white-space: nowrap;
}

.partner-item {
  flex: 0 0 auto;
  margin: 0 30px;
}

.partner-item img {
  height: 120px;
  max-width: 240px;
  object-fit: contain;
}

@-webkit-keyframes scroll-left {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}

@keyframes scroll-left {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-100%);
  }
}

.partner-marquee-wrapper:hover .partner-track {
  animation: none;
}

@media (max-width: 992px) {
  .partner-marquee {
    animation: scroll-left 25s linear infinite !important;
  }
}

/* Media query untuk mobile, pastikan marquee tetap jalan */
@media (max-width: 768px) {
  .partner-item img {
    height: 40px; /* Gambar lebih kecil di mobile */
  }

  .partner-marquee {
    animation: scroll-left 20s linear infinite;
    -webkit-animation: scroll-left 20s linear infinite;
  }

  .partner-track {
    min-width: 100%;
  }
  .header-container {
    margin-top: 25vh; /* atau padding-top */
  }
}

/* Responsive Design */
@media (max-width: 767.98px) {
  .logo-img {
    width: 7rem;
    height: auto;
  }
  .border-y {
    border-top: 2px solid #dee2e6;
    border-bottom: 2px solid #dee2e6;
    padding: 1rem 0;
  }
  #header {
    position: relative;
    z-index: 1;
    height: 100%;
    display: grid;
    padding: 0 1rem;
    margin-top: 3rem;
  }
  .header-container {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
  }
  .header-title {
    margin: 0;
    font-size: 24px;
    font-weight: 800;
    color: white;
  }
  .header-sub-title {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: #f7bd3a;
  }
  .header-description {
    color: white;
    padding-bottom: 0px !important;
  }
}

/* Desktop only */
@media (min-width: 768px) {
  .logo-img {
    width: auto;
    height: 48px;
  }
  .border-y {
    border-right: 2px solid #dee2e6;
    border-left: 2px solid #dee2e6;
  }
  #header {
    display: flex;
    align-items: center;
    position: relative;
    z-index: 1;
    height: 100%;
    padding: 0 1rem;
  }
  .container {
    max-width: 90%;
  }
  .header-container {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    max-width: 50%;
    margin-top: 25vh; /* atau padding-top */
  }
  .header-title {
    margin: 0;
    font-size: 64px;
    font-weight: 800;
    color: white;
    line-height: 105%;
  }
  .header-sub-title {
    margin: 0;
    font-size: 32px;
    font-weight: 800;
    color: #f7bd3a;
  }
  .header-description {
    color: #ffffff;
    font-size: 20px;
  }
}

/* --- SERVICES SECTION 3D CARD ANIMATIONS --- */

.service-card-wrapper {
  position: relative;
  background: rgba(13, 43, 94, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 20px;
  padding: 35px 24px;
  text-align: center;
  cursor: pointer;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  transition: all 0.6s cubic-bezier(0.34, 1.56, 0.64, 1);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  
  /* Initial hidden state for scroll animation */
  opacity: 0;
  transform: translateY(60px) rotateX(15deg) rotateY(10deg) scale(0.9);
  transform-style: preserve-3d;
  perspective: 1000px;
}

/* Scroll Visibility Trigger */
.efunding-services-visible .service-card-wrapper {
  opacity: 1;
  transform: translateY(0) rotateX(0deg) rotateY(0deg) scale(1);
}

/* Staggered transition delays for entrance */
.efunding-services-visible .row > div:nth-child(1) .service-card-wrapper {
  transition-delay: 0.1s;
}
.efunding-services-visible .row > div:nth-child(2) .service-card-wrapper {
  transition-delay: 0.25s;
}
.efunding-services-visible .row > div:nth-child(3) .service-card-wrapper {
  transition-delay: 0.4s;
}

/* 3D Tilt Hover Effects */
.service-card-wrapper:hover {
  transform: translateY(-8px) rotateX(6deg) rotateY(-6deg) scale(1.03);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.35);
  border-color: #f7bd3a;
  background: rgba(13, 43, 94, 0.6);
}

.service-card-glow {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 50% 50%, rgba(247, 189, 58, 0.18) 0%, transparent 70%);
  opacity: 0;
  transition: opacity 0.4s ease;
  pointer-events: none;
  z-index: 1;
}

/* Ribbon Container for Segera Hadir */
.ribbon-wrapper {
  width: 90px;
  height: 90px;
  overflow: hidden;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
  pointer-events: none;
}

/* Diagonal Ribbon Text */
.ribbon-text {
  text-align: center;
  font-family: 'Poppins', sans-serif;
  font-size: 9px;
  font-weight: 700;
  color: #13346c;
  background-color: #f7bd3a;
  text-transform: uppercase;
  padding: 4px 0;
  position: relative;
  left: -8px;
  top: 16px;
  width: 130px;
  transform: rotate(45deg);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  letter-spacing: 0.5px;
}

.service-card-wrapper:hover .service-card-glow {
  opacity: 1;
}

.service-card-inner {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.service-icon-container {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.05);
  margin-bottom: 24px;
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.service-card-wrapper:hover .service-icon-container {
  background: rgba(247, 189, 58, 0.12);
  border-color: rgba(247, 189, 58, 0.3);
  transform: scale(1.12) rotate(8deg);
}

.service-icon {
  width: 50px;
  height: auto;
  transition: all 0.4s ease;
}

.service-title {
  color: white;
  font-size: 20px;
  font-weight: 700;
  margin-bottom: 12px;
  transition: color 0.3s ease;
}

.service-card-wrapper:hover .service-title {
  color: #f7bd3a;
}

.service-description-text {
  color: #b3b3b3;
  font-size: 14px;
  line-height: 1.6;
  margin-bottom: 0;
  text-align: center;
  transition: color 0.3s ease;
}

.service-card-wrapper:hover .service-description-text {
  color: #e6e6e6;
}


/* Pros Section Hover & Float */
#efunding-pros .col-12.col-lg-4 {
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  padding: 16px;
  border-radius: 12px;
}
#efunding-pros .col-12.col-lg-4:hover {
  transform: translateY(-4px);
  background-color: rgba(255, 255, 255, 0.03);
}
#efunding-pros .col-12.col-lg-4 img {
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
}
#efunding-pros .col-12.col-lg-4:hover img {
  transform: scale(1.1) translateY(-2px);
  filter: drop-shadow(0 4px 12px rgba(247, 189, 58, 0.5));
}

/* Float Animations for Pros Section Icons */
#efunding-pros .row .col-12.col-lg-4:nth-child(1) img {
  animation: float-slow 6s ease-in-out infinite;
}
#efunding-pros .row .col-12.col-lg-4:nth-child(2) img {
  animation: float-slow 7s ease-in-out infinite 1s;
}
#efunding-pros .row .col-12.col-lg-4:nth-child(3) img {
  animation: float-slow 6.5s ease-in-out infinite 0.5s;
}

@keyframes float-slow {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-6px);
  }
}

/* Partners Marquee Hover Effect */
.partner-item img {
  transition: all 0.3s ease-in-out;
  opacity: 1;
  filter: none;
}
.partner-item img:hover {
  transform: scale(1.08);
}

/* Deep Styles for Child Components */
::v-deep .card-abstract-item {
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
}
::v-deep .card-abstract-item:hover {
  transform: translateY(-5px) scale(1.03);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.2) !important;
  background-color: #08224d !important;
}

::v-deep .card-item {
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
}
::v-deep .card-item:hover {
  transform: translateY(-8px) scale(1.02);
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.18) !important;
}

::v-deep .faq-button {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}
::v-deep .faq-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 18px rgba(247, 189, 58, 0.35);
  background-color: #f7bd3a !important;
  color: #13346c !important;
}

/* Jumbotron slider control hover */
.carousel-prev-slide,
.carousel-next-slide {
  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}
.carousel-prev-slide:hover,
.carousel-next-slide:hover {
  color: #f7bd3a;
  transform: scale(1.25);
}

/* --- PROS SECTION STYLES (NATURAL SCROLL) --- */
.pros-normal-container {
  padding: 80px 0;
  position: relative;
  overflow: visible !important;
}
.pros-views-wrapper {
  margin-top: 50px;
  display: flex;
  flex-direction: column;
  gap: 80px;
}
.pros-view-pane {
  position: relative;
  width: 100%;
}
.pros-header {
  font-size: 28px;
  font-weight: 700;
  color: white;
  margin-bottom: 20px;
}
@media (max-width: 991px) {
  .pros-normal-container {
    padding: 50px 0;
  }
  .pros-views-wrapper {
    gap: 50px;
  }
  .pros-header {
    text-align: center;
    font-size: 22px;
    margin-bottom: 15px;
  }
  .pros-view-pane .section-description {
    text-align: center !important;
    margin-bottom: 30px;
  }
}

/* --- CONTINUOUS FLOATING ANIMATIONS --- */
@keyframes float-slow-y {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-8px);
  }
}

/* Floating for Service Cards (Layanan Efunding) */
.service-card-inner {
  animation: float-slow-y 6s ease-in-out infinite;
}
.row > div:nth-child(1) .service-card-inner {
  animation-delay: 0s;
}
.row > div:nth-child(2) .service-card-inner {
  animation-delay: 1.5s;
}
.row > div:nth-child(3) .service-card-inner {
  animation-delay: 3s;
}

/* Floating for Feature Cards (Mengapa Efunding) */
.pros-feature-card {
  animation: float-slow-y 5s ease-in-out infinite;
}
.pros-features-row > div:nth-child(1) .pros-feature-card {
  animation-delay: 0s;
}
.pros-features-row > div:nth-child(2) .pros-feature-card {
  animation-delay: 1.2s;
}
.pros-features-row > div:nth-child(3) .pros-feature-card {
  animation-delay: 2.4s;
}

/* --- PROS FEATURES ANIMATED CAPSULE CARDS --- */
.pros-features-row {
  width: 100%;
}
.pros-feature-card {
  position: relative;
  background: rgba(13, 43, 94, 0.4);
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 16px;
  padding: 24px 16px;
  text-align: center;
  cursor: default;
  width: 100%;
  max-width: 160px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}
.pros-feature-card .ribbon-wrapper {
  width: 72px;
  height: 72px;
}
.pros-feature-card .ribbon-text {
  font-size: 7.5px;
  padding: 2.5px 0;
  left: -11px;
  top: 13px;
  width: 105px;
}
.pros-feature-card:hover {
  transform: translateY(-6px) scale(1.04);
  box-shadow: 0 12px 24px rgba(0, 0, 0, 0.25);
  border-color: #f7bd3a;
  background: rgba(13, 43, 94, 0.65);
}
.pros-feature-glow {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 50% 50%, rgba(247, 189, 58, 0.15) 0%, transparent 70%);
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
  z-index: 1;
}
.pros-feature-card:hover .pros-feature-glow {
  opacity: 1;
}
.pros-feature-icon-wrapper {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.03);
  margin-bottom: 12px;
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  border: 1px solid rgba(255, 255, 255, 0.05);
  z-index: 2;
}
.pros-feature-card:hover .pros-feature-icon-wrapper {
  background: rgba(247, 189, 58, 0.1);
  border-color: rgba(247, 189, 58, 0.25);
  transform: scale(1.1) rotate(6deg);
}
.pros-feature-icon {
  width: 40px;
  height: auto;
  transition: all 0.4s ease;
}
.pros-feature-card:hover .pros-feature-icon {
  filter: drop-shadow(0 2px 8px rgba(247, 189, 58, 0.4));
}
.pros-feature-text {
  color: #b3b3b3;
  font-size: 13px;
  line-height: 1.4;
  margin-bottom: 0;
  text-align: center;
  font-weight: 500;
  z-index: 2;
  transition: color 0.3s ease;
}
.pros-feature-card:hover .pros-feature-text {
  color: white;
}

/* --- SCROLL REVEAL ANIMATIONS (Bottom to Top) --- */
.reveal-on-scroll {
  opacity: 0;
  transform: translateY(70px);
  transition: opacity 0.85s cubic-bezier(0.25, 1, 0.5, 1),
              transform 0.85s cubic-bezier(0.25, 1, 0.5, 1);
  will-change: transform, opacity;
}

.reveal-on-scroll.revealed {
  opacity: 1;
  transform: translateY(0);
}
</style>

<style>
/* Global style override to ensure position: sticky works */
html, body {
  overflow-x: visible !important;
  overflow-x: clip !important;
}
main {
  overflow: visible !important;
}
/* Prevent slider arrow buttons from being cut off in the product section */
#efunding-selected-product {
  overflow: visible !important;
}
</style>




// WEBPACK FOOTER //
// src/public/index.vue